import { ScheduleSend } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useState } from "react";

export default function ScheduleButtonContainer({
  mutation,
  dt,
  setDt,
  isDisabled,
}) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setDt(null);
    setOpen(false);
  };

  const handleSchedule = () => {
    if (dt.getTime() < Date.now()) {
      alert("Posts cannot be scheduled in the past");
      return;
    }
    mutation.mutate();
  };

  const getTomorrowMorning = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(9, 0, 0, 0);
    return d;
  };

  const getTomorrowAfternoon = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(13, 0, 0, 0);
    return d;
  };

  const getDayAfterTomorrowMorning = () => {
    const d = new Date();
    d.setDate(d.getDate() + 2);
    d.setHours(9, 0, 0, 0);
    return d;
  };

  const setTomorrowMorning = () => {
    setDt(getTomorrowMorning());
  };

  const setTomorrowAfternoon = () => {
    setDt(getTomorrowAfternoon());
  };

  const setDayAfterTomorrowMorning = () => {
    setDt(getDayAfterTomorrowMorning());
  };

  const dayAfterTomorrowName = getDayAfterTomorrowMorning().toLocaleDateString(
    "en-US",
    { weekday: "long" }
  );

  const userTimezone = Intl.DateTimeFormat()
    .resolvedOptions()
    .timeZone.replace(/_/g, " ");

  // const isDisabled = text.length === 0 || mutation.isPending;

  return (
    <Box>
      <IconButton
        // sx={{
        //   background: isDisabled && "rgba(256,256,256,0.1)",
        // }}
        size="small"
        color="secondary"
        onClick={handleClick}
        disabled={isDisabled}
      >
        <ScheduleSend />
      </IconButton>

      <Dialog
        open={open}
        // onClose={handleClose} // dont want the user to close the dialog
        sx={{
          "& .MuiDialog-paper": {
            p: 4,
          },
        }}
      >
        <Typography variant="h6">Schedule Post</Typography>
        <Box sx={{ px: 0, mt: 2 }}>
          <Stack spacing={1} sx={{ mb: 2 }}>
            <Button
              onClick={setTomorrowMorning}
              variant={
                dt?.getTime() === getTomorrowMorning().getTime()
                  ? "contained"
                  : "outlined"
              }
              color="secondary"
            >
              Tomorrow morning
            </Button>
            <Button
              onClick={setTomorrowAfternoon}
              variant={
                dt?.getTime() === getTomorrowAfternoon().getTime()
                  ? "contained"
                  : "outlined"
              }
              color="secondary"
            >
              Tomorrow afternoon
            </Button>
            <Button
              onClick={setDayAfterTomorrowMorning}
              variant={
                dt?.getTime() === getDayAfterTomorrowMorning().getTime()
                  ? "contained"
                  : "outlined"
              }
              color="secondary"
            >
              {dayAfterTomorrowName} morning
            </Button>
          </Stack>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="Date & Time"
              value={dt}
              onChange={(newValue) => setDt(newValue)}
              sx={{ my: 2 }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  helperText: userTimezone,
                },
              }}
              disablePast
            />
          </LocalizationProvider>
        </Box>
        <Box sx={{ py: 2 }}>
          <Stack direction="row" justifyContent="space-between" width="100%">
            <Button
              onClick={handleClose}
              disabled={mutation.isPending}
              color="info"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSchedule}
              variant="outlined"
              color="secondary"
              disabled={mutation.isPending || !dt || dt.getTime() < Date.now()}
              startIcon={
                mutation.isPending ? (
                  <CircularProgress size={16} />
                ) : (
                  <ScheduleSend />
                )
              }
            >
              Schedule
            </Button>
          </Stack>
        </Box>
      </Dialog>
    </Box>
  );
}
